import { render, staticRenderFns } from "./ManageSica.vue?vue&type=template&id=efef17c4&"
import script from "./ManageSica.vue?vue&type=script&lang=js&"
export * from "./ManageSica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports